import { render, staticRenderFns } from "./StoreDia.vue?vue&type=template&id=59f1d474&scoped=true"
import script from "./StoreDia.vue?vue&type=script&lang=js"
export * from "./StoreDia.vue?vue&type=script&lang=js"
import style0 from "./StoreDia.vue?vue&type=style&index=0&id=59f1d474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f1d474",
  null
  
)

export default component.exports